import { useImpersonateWorkspace } from '../../workspace/hooks/useImpersonateWorkspace';
import { useAccessTokenReceived } from './useAccessTokenReceived';
import { useCurrentWorkspace } from './useCurrentWorkspace';
import { ImpersonationDraft } from './useImpersonationDraft';
import { useImpersonateUser } from './useImpersonateUser';
import { useIsInImpersonateUser } from './useIsInImpersonateUser';

export const useApplyImpersonation = () => {
  const isInImpersonateUser = useIsInImpersonateUser();
  const currentWorkspace = useCurrentWorkspace(true);
  const { impersonateWorkspace } = useImpersonateWorkspace();
  const { impersonateUserAsync } = useImpersonateUser();
  const onAccessTokenReceived = useAccessTokenReceived();

  const cancel = async () => {
    if (isInImpersonateUser) {
      await onAccessTokenReceived('', true, false);
    }
    if (currentWorkspace) {
      await impersonateWorkspace(undefined);
    }
  };

  const apply = async (draft: ImpersonationDraft) => {
    await cancel();

    if (draft.userId) {
      await impersonateUserAsync({ accountId: draft.userId }, () => null);
      return;
    }

    if (draft.workspaceId !== undefined) {
      await impersonateWorkspace({
        id: draft.workspaceId,
        name: draft.workspaceName ?? '',
        type: draft.workspaceType,
      });
    }
  };

  return { apply, cancel };
};
